import React from 'react';
import { useParams } from 'react-router-dom';

import { useGetProductCategoryById } from '@occc-app/dataAccessLayer/productCategory/queries';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { ProductCategoryDetailsPage } from './ProductCategoryDetailsPage';

export const ProductCategoryDetailsPageContainer: React.FC = () => {
  const { id: productCategoryId = '' } = useParams<{ id: string }>();
  const { loading, error, data } = useGetProductCategoryById(productCategoryId);
  const isUserPermittedToEditProductCategory = useIsUserPermittedTo(Feature.PRODUCT_CATEGORY_EDIT);

  return (
    <ProductCategoryDetailsPage
      loading={loading}
      error={error}
      productCategory={data}
      isUserPermittedToEditProductCategory={isUserPermittedToEditProductCategory}
    />
  );
};
